import styled from 'styled-components'

export const Title = styled.h1(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '3.6rem',
  fontWeight: 600,
  marginBottom: theme.space['24'],
  textAlign: 'center',
}))

export const Heading = styled.h3(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '2rem',
  fontWeight: 600,
}))

export const DetailsCardContainer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['12'],
}))

export const Separator = styled.hr(({ theme }) => ({
  backgroundColor: theme.colors.gray300,
  height: '0.1rem',
  margin: 0,
  width: '100%',
}))
